import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop: React.FC = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
